import React, { forwardRef } from "react";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { injectStylesInString } from "../../signUpHelpers";

type OfferBoxProps = {
  title: string;
  copy: string;
  name: string;
  value: string;
  isSelected: boolean;
};

// eslint-disable-next-line react/display-name
const OfferBox = forwardRef<any, OfferBoxProps>(
  ({ title, copy, name, value, isSelected }, ref) => {
    return (
      <label
        className={`offerbox-signup__label flex flex-col justify-center items-start gap-[10px] p-6 sm:p-4 border border-solid rounded-xl cursor-pointer 
      ${
        isSelected
          ? "bg-mint-100 border-mint-500"
          : "bg-white border-forest-300"
      }`}
        htmlFor={`${name}/${value}`}
      >
        <div className="flex justify-start items-center [@media(max-width:375px)]:items-start gap-[6px] self-stretch">
          <RadioGroup.Item
            className={`offerbox-signup__btn size-4 m-[2px] shrink-0 [@media(max-width:375px)]:mt-[5px] bg-white rounded-full ${
              !isSelected && "border border-solid border-forest-200"
            }`}
            value={value}
            ref={ref}
            checked={isSelected}
            id={`${name}/${value}`}
          >
            <RadioGroup.Indicator
              className="offerbox-signup__radio size-4 rounded-full flex items-center justify-center bg-forest-900
        after:size-[4.8px] after:shrink-0 after:rounded-full after:bg-white"
            />
          </RadioGroup.Item>
          <span className="text-[#333] font-sans text-base not-italic font-bold leading-[160%] cursor-pointer">
            {title}
          </span>
        </div>
        <p
          className="offerbox-signup__text pl-[26px] text-[#333] font-sans text-base not-italic font-normal leading-[160%]"
          dangerouslySetInnerHTML={
            copy
              ? {
                  __html: injectStylesInString(
                    copy,
                    "a",
                    "underline hover:no-underline"
                  ),
                }
              : undefined
          }
        />
      </label>
    );
  }
);

export default OfferBox;
